import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import AdminNavbar from '../../components/Navbar/AdminNavbar'
import { useFetchAdminData } from '../../services/adminService';
import { useSelector } from 'react-redux';
import { useAdminDashboardService } from '../../services/adminDashboardService';
import MainWrapper from '../../components/Wrappers/MainWrapper';

const Admin = () => {

    const { fetchAllUsersEmail, fetchAllFonts } = useFetchAdminData();
    const { fetchFilteredData,
        fetchOverAllRating,
        fetchOverAllRatingResult,
        fetchFeedbackComments,
        fetchFeedback1Rating,
        fetchFeedback2Rating,
        fetchFeedback3Rating
    } = useAdminDashboardService()

    const { fonts, users } = useSelector((state) => state.admin);

    useEffect(() => {
        const fetchData = async () => {
            await fetchAllUsersEmail();
            await fetchAllFonts();
        };

        if (fonts.length === 0 || users.length === 0) {
            fetchData();
        }
    }, []);

    useEffect(() => {
        if (users.length === 0 || fonts.length === 0) {
            // fetchFilteredData(1)
            fetchOverAllRating()
            fetchOverAllRatingResult()
            fetchFeedbackComments()
            fetchFeedback1Rating()
            fetchFeedback2Rating()
            fetchFeedback3Rating()
        }
    }, []);

    return (
        <MainWrapper className="">
            <AdminNavbar users={users} fonts={fonts} />
            <Outlet />
        </MainWrapper>
    )
}

export default Admin